<script setup lang="ts">
import { LoadingSpinner } from '.'

type Props = { isLoading: boolean }
defineProps<Props>()
</script>

<template>
    <LoadingSpinner :isFullPage="true" :isLoading="isLoading" :can-cancel="false">
        <slot />
    </LoadingSpinner>
</template>
